<template>
  <v-dialog v-model="showDialog" :max-width="maxWidth" persistent>
    <v-card class="card">
      <v-card-title class="px-4 py-4 text-center">
        <p class="my-auto">{{ title }}</p>
      </v-card-title>
      <v-col class="d-flex justify-space-between pa-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("commons.cancel")
        }}</v-btn>
        <v-btn class="bt-acept" text @click="confirm">{{
          $tc("commons.accept")
        }}</v-btn>
      </v-col>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    showDialog: Boolean,
    cancel: Function,
    confirm: Function,
    maxWidth: {
      type: String,
      default: "450px",
    },
    title: {
      type: String,
      default: "¿Está seguro que desea realizar esta acción?",
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
